import script from "./DownloadButtonArtWork.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadButtonArtWork.vue?vue&type=script&setup=true&lang=js"

import "./DownloadButtonArtWork.vue?vue&type=style&index=0&id=26bed1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26bed1aa"]])

export default __exports__